<div class="dashboard">
    <h2>Conversation Category Distribution</h2>
    <div class="filters">
    <mat-form-field appearance="outline">
    <mat-label>Start Date</mat-label>
    <input
        matInput
        [matDatepicker]="startPicker"
        [(ngModel)]="startDate"
        name="startDate"
    />
    <mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
    <mat-datepicker #startPicker></mat-datepicker>
    </mat-form-field>

    <mat-form-field appearance="outline">
    <mat-label>End Date</mat-label>
    <input
        matInput
        [matDatepicker]="endPicker"
        [(ngModel)]="endDate"
        name="endDate"
    />
    <mat-datepicker-toggle matSuffix [for]="endPicker"></mat-datepicker-toggle>
    <mat-datepicker #endPicker></mat-datepicker>
    </mat-form-field>


    <button mat-raised-button color="primary" (click)="fetchCategoryDistribution()">
        Load Data
    </button>
    </div>
    <mat-tab-group (selectedTabChange)="onTabChange($event)" class="analytics-tabs">

        <mat-tab label="Category Breakdown Chart">
            <!-- Chart -->
        <mat-card-content style="height: 400px; padding: 20px;">
        <canvas
            baseChart
            [data]="barChartData"
            [options]="barChartOptions"
            [type]="'bar'"
            (chartClick)="onBarChartClick($event)">
        </canvas>
        </mat-card-content>

        </mat-tab>
        <mat-tab label="Category Breakdown Table">
            <!-- Table -->
        <!-- <h3></h3> -->
        <table mat-table [dataSource]="categoryTable" class="mat-elevation-z8">
        <ng-container matColumnDef="category">
            <th mat-header-cell *matHeaderCellDef> Category </th>
            <td mat-cell *matCellDef="let row"> {{ row.conversation_category }} </td>
        </ng-container>

        <ng-container matColumnDef="count">
            <th mat-header-cell *matHeaderCellDef> Count </th>
            <td mat-cell *matCellDef="let row"> {{ row.count }} </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="['category', 'count']"></tr>
        <tr mat-row *matRowDef="let row; columns: ['category', 'count'];"></tr>
        </table>
        </mat-tab>

    </mat-tab-group>

<!-- Date Range Pickers -->
  <section class="tab-content">


</section>







</div>
